<template>
  <div>
          <div v-if="!loading" class="uk-section uk-position-relative uk-section-large uk-background-legible uk-background-cover uk-background-fixed uk-background-blend-multiply uk-padding hero" uk-height-viewport="offset-top: true" v-bind:style="{ backgroundImage: `url(${project?.image?.large4x3})`}">
          <!-- <label class="uk-">PROJECTS / {{project.title}}</label> -->
          <div class="uk-light uk-position-large uk-position-center-left hero-content-left uk-width-2-5@m uk-width-2-3@s uk-width-1-1@xs">

              <router-link to="/programs/projects"><label>Projects</label></router-link>
              <h1>{{project.title}}</h1>
              <p class="uk-text-lead">{{project.summary}}</p>
              <h3 class="uk-margin-medium-bottom"><em>{{project.quote}}</em></h3>

              <router-link :to="project.link + '/hero'" class="uk-button uk-button-primary theme-button" v-if="project.heroText">Meet the Hero</router-link>
              <router-link :to="project.link + '/storytellers'" class="uk-button theme-button button-green"  v-if="project.storytellersText">Storytellers</router-link>

          </div>
      </div>

  </div>
</template>

<script>
import FloatingBadge  from '../../components/FloatingBadge.vue'
import gql from 'graphql-tag'

export default {
    inject: ['theme'],
    props: ['project']
}
</script>
